import React, { Component } from 'react'
import './ScatterDetailModal.css'
import axios from 'axios'
import { message } from 'antd'
/**
 * 第一个import echarts是必须的
 * 第二个是引入的具体的一个图表类型 （可选）
 * 第三个是表的title(可选)
 * 第四个是表的工具栏组件相关的行为（可选，
   内置有导出图片，数据视图，动态类型切换，数据区域缩放，重置五个工具）
 */
import * as echarts from 'echarts/core'
import ReactECharts from 'echarts-for-react'
import {
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent
} from 'echarts/components';
import { LineChart } from 'echarts/charts';
// import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  LineChart,
  CanvasRenderer,
  // UniversalTransition
]);


export default class ScatterChart extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      // scatterFeatureGraphicPath:''//散射曲线文件路径
    }
    // this["scatterChart" + "-" + this.props.allData.key] = React.createRef()
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.nowSelectData !== prevProps.nowSelectData) {

      this.getScatterDataPath()
      // this.getMicroRSFeatureISARGraphicPath()
    }
  }

  async componentDidMount() {
    // console.log("componentDidMount",this.props);
    //初始化图表
    // this.initChart();
    // setTimeout(() => {
    //   this.initChart();
    // }, 1);
    // console.log(this.props)
    this.getScatterDataPath()
  }

  getScatterDataPath = async () => {
    const { nowSelectData, token } = this.props
    if (nowSelectData) {
      console.log(nowSelectData.data_file_location)
      let dataNames = nowSelectData.data_file_location
      const { data: res } = await axios.get(`/dataBaseDocQueryUrl/api/downloadMicroRSFeatureNCDataUrl?dataPath=${nowSelectData.data_file_location.replace(/\\/g, '%5C')}`, {
        headers: {
          Authorization: token
        }
      })
      console.log(res)
      if (res.code !== '0') {
        message.error('散射曲线获取失败！')
      } else {
        this.getScatterDatas(res.data[dataNames])
      }
    }
  }

  getScatterDatas = async (scatterDataPath) => {
    // http://10.0.36.106:9527/api/demo-service/nc/getByUrl?path=a
    const { data: res } = await axios.get(global.gatewayip + `/api/demo-service/nc/getByUrl?path=${scatterDataPath}`)
    console.log(res)
    if (res.code === '200') {
      this.echartsReact.getEchartsInstance().setOption({
        xAxis: {
          data: res.payload.xAxis
        },
        series: [
          {
            name: 'HH',
            type: 'line',
            smooth: true,
            data: res.payload.yAxis[0].data
          },
          {
            name: 'HV',
            type: 'line',
            smooth: true,
            data: res.payload.yAxis[1].data
          },
          {
            name: 'VV',
            type: 'line',
            smooth: true,
            data: res.payload.yAxis[3].data
          },
          {
            name: 'VH',
            type: 'line',
            smooth: true,
            data: res.payload.yAxis[2].data
          },
        ]
      })
    }
  }

  options = {
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['HH', 'HV', 'VV', 'VH']
    },
    grid: {
      left: '3%',
      right: '2%',
      bottom: '30%',
      top: '12%',
      containLabel: true
    },
    xAxis: {
      name: '频率/GHz',
      nameLocation: 'middle',
      nameGap: '20',
      nameTextStyle: {
        fontWeight: 'bolder',
        fontSize: '12'
      },
      type: 'category',
      boundaryGap: false,
      data: [],
      axisLabel: {
        interval: 19
      }
      // data: ['2', '4', '6', '8']
    },
    yAxis: {
      name: 'RCS/dBsm',
      nameLocation: 'end',
      nameGap: '8',
      nameTextStyle: {
        fontWeight: 'bolder',
        fontSize: '12'
      },
      type: 'value'
    },
    dataZoom: [
      {
        type: 'inside',
        start: 0,
        end: 10
      },
      {
        start: 0,
        end: 10
      }
    ],
    series: [
      {
        name: 'HH',
        type: 'line',
        smooth: true,
        // stack: 'Total',
        data: []
      },
      {
        name: 'HV',
        type: 'line',
        smooth: true,
        // stack: 'Total',
        data: []
      },
      {
        name: 'VV',
        type: 'line',
        smooth: true,
        // stack: 'Total',
        data: []
      },
      {
        name: 'VH',
        type: 'line',
        smooth: true,
        // stack: 'Total',
        data: []
      },
    ]
  }

  render() {
    return (
      //width和height可由属性值传入
      <div style={{ width: '100%', height: '100%' }}>
        <ReactECharts
          className="scatter-chart"
          ref={e => this.echartsReact = e}
          option={this.options}
          echarts={echarts}
          lazyUpdate={true}
        ></ReactECharts>
      </div>
    );
  }
};
